import { Button, Grid } from '@mui/material';
import { useEffect, useState } from 'react';

import ImageListModal, {
  ImageModal,
} from '@/shared/components/ui/Images/ImageListModal/ImageListModal';
import { calcOTImages } from '@/shared';
import { TabTextLabel } from '@/shared/components/ui';
import { ScrollableDialogProps } from '@/shared/components/ui/Dialogs';
import { OrdenTrabajo } from '@/shared/interfaces';

export type ValidateFotosEntradaOTActivacionModalProps = {
  open: boolean;
  onClose: () => void;

  ordenTrabajo: OrdenTrabajo;
};

const ValidateFotosEntradaOTActivacionModal: React.FC<
  ValidateFotosEntradaOTActivacionModalProps
> = ({ ordenTrabajo, onClose, open }) => {
  ///* local state ------------
  const [imagesArr, setImagesArr] = useState<ImageModal[]>([]);

  ///* handlers ------------
  const handleClose = () => {
    onClose();
  };

  ///* effects ------------
  useEffect(() => {
    if (!open) return;

    // antes era async
    const fotosEntrada = calcOTImages(ordenTrabajo, 'urls_fotos_entrada');
    console.log("fotosEntrada", fotosEntrada);
    setImagesArr(fotosEntrada);
  }, [open]);

  return (
    <>
      <ScrollableDialogProps
        open={open}
        title="Fotos de Entrada"
        minWidth="54%"
        minHeight="30vh"
        contentNode={
          <>
            <Grid item xs={12} container spacing={3}>
              <>
                {/* ----- Image Modal ----- */}
                <Grid item xs={12}>
                  <TabTextLabel text="Fotos de Entrada" pt="0" pl="0" pb="0" />
                </Grid>
                <ImageListModal images={imagesArr || []} />
              </>
            </Grid>
          </>
        }
        onClose={handleClose}
        showCustomButtons
        customButtons={
          <>
            <Grid
              item
              container
              xs={12}
              alignItems="center"
              justifyContent="flex-end"
            >
              <Button
                onClick={() => {
                  handleClose();
                }}
                variant="text"
                color="inherit"
              >
                Cerrar
              </Button>
              <span className="spacer" />
            </Grid>
          </>
        }
      />
    </>
  );
};

export default ValidateFotosEntradaOTActivacionModal;
